/* eslint no-param-reassign: "off", no-console: "off" */
import Vuex from 'vuex';

const accountStore = {
  state: {
    selectedAccount: null,
    accounts: [],
    sharedAccounts: [],
  },
  mutations: {
    fetchAccount(state, payload) {
      state.selectedAccount = state.accounts.find(a => a.id == payload);
    },
    fetchAccounts(state, payload) {
      state.accounts = payload;
    },
    addAccount(state, payload) {
      state.accounts.push(payload);
    },
    fetchSharedAccounts(state, payload) {
      state.sharedAccounts = payload;
    }
  },
  actions: {
    async fetchAccounts({ commit }) {
      // get from cache first
      try {
        const accounts = [];
        // eslint-disable-next-line no-undef
        $accountStore.iterate((value) => {
          accounts.push(value);
        }).then(() => {
          commit('fetchAccounts', accounts);
        });
      } catch (ex) { console.error(ex); }

      try {
        const res = await fetch('/v2/accounts');
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchAccounts', data);
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    async addAccount({ commit }, payload) {
      try {
        const res = await fetch('/v2/accounts', {
          body: JSON.stringify(payload),
          method: 'POST',
          headers: new Headers({ 'Content-Type': 'application/json' })
        });
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('addAccount', data);
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    async fetchSharedAccounts({ commit }) {
      // get from cache first
      try {
        const sharedAccounts = [];
        // eslint-disable-next-line no-undef
        $accountStore.iterate((value) => {
          sharedAccounts.push(value);
        }).then(() => {
          commit('fetchSharedAccounts', sharedAccounts);
        });
      } catch (ex) { console.error(ex); }

      try {
        const res = await fetch('/v2/accounts/sharedWith');
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchSharedAccounts', data);
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    async clearAccountCache() {
      // eslint-disable-next-line no-undef
      await $accountStore.clear();
      return true;
    }
  },
  getters: {

  }
}
export default accountStore;
export const useAccountsStore = () => new Vuex.Store(accountStore);
